export default {"src":"/_next/static/media/map_pin_house.330f4044.svg","height":27,"width":24,"blurWidth":0,"blurHeight":0};